import { z } from "zod";
import { privateProductSourceHostnameSchema } from "./private-product-sources.js";
const fields = {
    sourceId: z.string().uuid(),
    hostname: privateProductSourceHostnameSchema,
    brand: z
        .string()
        .trim()
        .min(2)
        .max(100)
        .regex(/^[^\p{C}]+$/u),
    registrationKind: z.enum(["OPERATOR_REVIEW", "AUTHORIZED_AUTOMATION"]),
    sourceReference: z.string().trim().min(10).max(2000),
    identityEvidenceIds: z.array(z.string().uuid()).min(1).max(8),
    validFrom: z.string().date(),
    validTo: z.string().date().nullable(),
};
const valid = (value) => (value.validTo === null || value.validTo >= value.validFrom) &&
    new Set(value.identityEvidenceIds).size === value.identityEvidenceIds.length;
/** A primary brand publisher is not a declaration of a legal manufacturer or tax regime. */
export const applianceBrandIdentityCreateSchema = z.object(fields).strict().refine(valid);
export const applianceBrandIdentityRecordSchema = z
    .object({
    ...fields,
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    supplierId: z.string().uuid(),
    role: z.literal("BRAND_PUBLISHER"),
    status: z.literal("DECLARED"),
    registeredBy: z.string().uuid(),
    createdAt: z.string().datetime(),
    registrationSha256: z.string().regex(/^[a-f0-9]{64}$/),
    proofSha256: z.string().regex(/^[a-f0-9]{64}$/),
})
    .strict()
    .refine(valid);
export const applianceBrandIdentityListSchema = z
    .object({ items: z.array(applianceBrandIdentityRecordSchema).max(1000) })
    .strict();
//# sourceMappingURL=appliance-brand-identities.js.map